import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HcSelectItem } from '@hotmart-org-ca/cosmos-web/dist/react/hc-select';
export function SelectItem({ value, children, icon, iconPosition, selected = false }) {
    return (_jsxs(HcSelectItem, { value: value, selected: selected, iconPosition: iconPosition, children: [children, icon && _jsx("div", { slot: "icon", children: icon })] }));
}
